import { useStore } from 'store/store';

export const useHasFeature = (props: { feature: string; variation: string }) => {
  const store = useStore();
  return {
    enabled: store.userFeatures[props.feature] == props.variation
  };
};
